import GatedPageLayout from "components/GatedPage/GatedPageLayout";
import gatedFeedbackImage from "icons/gated-feedback-image.svg";

export default function GatedFeedbackUpsell() {
  return (
    <GatedPageLayout
      heading="Effortlessly collect candidate feedback"
      description="Measure and improve your candidate experience with simple, automated surveys candidates love."
      learnMoreLink="https://support.guide.co/en/articles/5395768-introducing-candidate-feedback-automatically-survey-candidates-after-each-interview"
      learnMoreLinkCaption="Learn more about Feedback "
      gatedModuleName="Feedback"
      image={gatedFeedbackImage}
    />
  );
}
